import { of } from 'rxjs';
import { TranslationService } from './Translation.service';

const getMock: () => Partial<TranslationService> = () => ({
    key: (key: string) => key,
    keyFormatter: (key: string, ...params: any[]) => key,
    isEnglish: () => true,
    fullSiteLanguagesList: Promise.resolve([]),
    notImplementedKey: (key: string) => key,
    fetchSupportedSiteLanguages: () =>
        of([
            { localeCode: 'en-US', displayName: 'English' },
            { localeCode: 'fr-FR', displayName: 'French (France)' },
            { localeCode: 'es-ES', displayName: 'Spanish (Spain)' }
        ])
});

export const translationServiceMock = {
    getMock,
    provider: (Service: typeof TranslationService) => ({
        provide: Service,
        useValue: getMock()
    })
};
